<script setup lang="ts">
defineProps<{
    destination?: string;
}>();
</script>

<template>
    <div class="final-destination-container">
        <div class="title" />
        <div class="sep">
            <mr-divider
                vertical
                class="divider"
                border-style="dashed"
                size="10px"
                color="var(--cool-gray-400)"
            />
            <div class="circle" />
        </div>
        <div class="title">
            {{ destination }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.final-destination-container {
    display: flex;
    align-items: flex-end;
}

.title {
    @include tg-m($w5, usePalette($p-cool-gray, $p-600));
    width: 62px;
    margin-bottom: -8px;
}

.sep {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 20px;
    margin: 0 20px;
    .divider {
        align-self: center;
        margin: 8px 0;
    }
    .circle {
        width: 10px;
        height: 10px;
        border: 2px solid usePalette($p-cool-gray, 400);
        border-radius: 100%;
    }
}
</style>
